<script>
import BaseLabel from "@/components/BaseLabel.vue";

export default {
    name: "BaseSwitch",
    components: { BaseLabel },
    props: {
        modelValue: Boolean,
        label: {
            type: String,
            required: false,
        },
        left: {
            type: String,
            required: true,
        },
        right: {
            type: String,
            required: true,
        },
    },
    emits: ["update:modelValue"],
    computed: {
        value: {
            get() {
                return this.modelValue;
            },
            set(value) {
                this.$emit("update:modelValue", value);
            },
        },
    },
};
</script>

<template>
    <div class="flex flex-col gap-2">
        <BaseLabel v-if="label">{{ label }}</BaseLabel>
        <div class="inline-flex items-center font-condensed font-medium">
            <span>{{ left }}</span>
            <div
                :class="[
                    'group mx-2 flex w-11 rounded-full border-2 border-green-900 bg-black p-1 hover:cursor-pointer hover:border-green-600',
                ]"
                @click="value = value === false"
            >
                <div
                    :class="
                        value === true ? 'translate-x-full' : 'translate-x-0'
                    "
                    class="h-4 w-4 rounded-full bg-green-900 transition-transform group-hover:bg-green-600"
                />
            </div>
            <span>{{ right }}</span>
        </div>
    </div>
</template>

<style scoped></style>
